import * as React from 'react';
import { Box, Card, CardContent, Typography, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';

// Safely render search headline HTML from the backend (ts_headline).
// Only allows <b> tags for keyword highlighting; all other content is
// rendered as plain text, preventing XSS from stored message content.
function renderHighlightedText(html) {
    if (!html) return null;
    const parts = html.split(/<b>(.*?)<\/b>/g);
    return parts.map((part, i) => {
        if (i % 2 === 1) {
            return <b key={i}>{part}</b>;
        }
        return part;
    });
}

export default function TextSearchResults({ data, loading }) {
    if (loading) {
        return <LinearProgress />;
    }

    if (!data || !data.length) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                    No results found
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                Found {data.length} message{data.length !== 1 ? 's' : ''}
            </Typography>
            {data.map((result, index) => (
                <Card key={`${result.message_id}-${index}`} sx={{ mb: 2 }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                            <Box>
                                <Typography variant="subtitle2" color="text.secondary">
                                    Message ID: {result.message_id}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    From: {result.sender} {result.name && `(${result.name})`}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Date: {new Date(result.date).toLocaleString()}
                                </Typography>
                            </Box>
                            <Chip
                                label="View Thread"
                                component={Link}
                                to={`/thread/${result.thread_id}?view_as=${result.sender}&focus=${result.message_id}`}
                                clickable
                                size="small"
                                variant="outlined"
                            />
                        </Box>
                        <Box sx={{ mt: 1, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    '& b': {
                                        backgroundColor: 'yellow',
                                        fontWeight: 'bold'
                                    }
                                }}
                            >
                                {renderHighlightedText(result.headline)}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
}